import React from 'react';
import { Carousel } from 'react-bootstrap';
import * as styles from '../css/feedback-carousel-container.css';

const FeedbackCarouselContainer: React.FC = ({ children }) => (
    <Carousel className={styles.root}>
        {children}
    </Carousel>
);

export default FeedbackCarouselContainer;
